module.exports = __webpack_public_path__ + "media/images/web_suite/ws_email_banner-3c3c7faab6ef14ac59b35c2b67adc194.png";